module.exports = __webpack_public_path__ + "34bc775d/img/ion_calendar-number.3ac5bd07.svg";